export const deleteMutltipleAccounts = ()=>{
    console.log('ff')
}


export const getApprenticeName = (data)=>{
    if (data) {
		return data?.name1 + " " + data?.name2;
	} 
	else return "---";
}